/**
 * Error Messages Constants
 * Contains all error messages, log messages, and error handling related constants
 */

export const ERROR_DEFAULT_MESSAGE =
  '¡Ups! Parece que hemos encontrado un problema en Creci. Lamentamos los inconvenientes. Para una solución rápida, por favor, envía un correo a nuestro equipo de soporte: soporte.creci@pragma.com.co.  Si eres líder de chapter, también puedes escribir en el grupo "Herramienta - Mapa de Crecimiento" . Estamos listos para ayudarte a resolver cualquier problema que puedas tener.';

export const ERROR_SELF_ASSESSMENT_BEHAVIORS = 'Failed to fetch review behaviors';

export const ERROR_MESSAGES = {
  CALENDAR_NOT_CONFIGURED: {
    backendException: 'SpecialtyRulesNotFound',
    title: 'Tu chapter aún no está habilitado para agendar',
    description:
      'Por favor, comunícate con tu líder de chapter para programar tu review de crecimiento y recibir orientación sobre los próximos pasos.',
  },
  SCHEDULING_STEPS_BAD_RESPONSE_JSON: {
    type: 'warning',
    title: 'Error Code: 422',
    description:
      'El json de configuración de pasos tiene un error, comunicarse con el equipo de soporte: soporte.creci@pragma.com.co',
  },
};

export enum LogMessages {
  ROLE_FORM_SUBMIT_INVALID = '[RoleFormFacade] submit invalid',
  DEFAULT_ERROR = '[ERROR]',
  INVALID_PRAGMATIC_ID = '[RoleFormFacade.save] pragmaticId inválido, abortando save',
  ERROR_PRAGMATIC_PROFILE = '[RoleFormFacade.save] Error obteniendo pragmatic profile',
  INVALID_PRAGMATIC_ID_SENIORITY_INFO = '[SenioritiesInfo.save] pragmaticId inválido, abortando save',
  ERROR_PRAGMATIC_PROFILE_SENIORITY_INFO = '[SenioritiesInfo.save] Error obteniendo pragmatic profile',
  MISSING_STEP_ONE_DATA_SENIORITY_INFO = '[SenioritiesInfo.save] Faltan datos del paso 1',
  ERROR_SAVING_SENIORITY_INFO = '[SenioritiesInfo.save] Error al guardar',
  ERROR_LOADING_SENIORITIES_INFO = '[SenioritiesInfo.loadSeniorities] Error al cargar seniorities',
  ERROR_LOADING_TEAM_PRAGMAPOWERS = '[SenioritiesInfo.loadTeamPragmaPowers] Error al cargar Team PragmaPowers',
  ERROR_LOADING_ROLE_DATA = '[SenioritiesInfo.loadExistingRoleData] Error al cargar datos del rol',
  ERROR_RELOADING_ROLE_DATA = '[SenioritiesInfo.reloadRoleDataFromBackend] Error al recargar datos',
}

export enum showErroMessage {
  completeFieldError = 'Completa este campo',
  ServerError = 'Error en el servidor',
}

export const ERROR_LOG_MESSAGES = {
  FETCH_ROLES: '[RoleService] Error al obtener roles:',
  FETCH_CHAPTER_ACCESS: '[PragmaticsService] Error al obtener acceso a chapters:',
  GOOGLE_SIGNIN_ERROR: '[LoginComponent] Error al autenticar con Google:',
  SCHEDULE_AVAILABILITY_CHECK: 'Error checking schedule availability:',
  SCHEDULE_VALIDATION: 'Error validating schedule availability:',
  OTHER_SCHEDULES_CHECK: 'Error checking other schedules on same day:',
};

export const WARNING_LOG_MESSAGES = {
  INVALID_DATE_PROVIDED: 'FormatDatePipe: Invalid date provided',
};

export const ENVIRONMENT_CHECK_WARNING =
  '[LoginComponent] Advertencia: No se pudo verificar el ambiente.';
export const ERR_MISSING_CHAPTER_OR_SPECIALITY = 'Faltan chapterId o specialityId';
export const ERR_FETCHING_DIFFERENTIAL_VALUES = 'Error al obtener valores diferenciales:';
export const ERR_FETCHING_SENIORITIES = 'Error al obtener seniorities:';
export const ERROR_FETCHING_DIFFERENTIAL_VALUE = 'Error al obtener el valor diferencial';

export const ERROR_SKILLSET = {
  SAVE_BEHAVIOR: {
    title: 'Error al guardar el comportamiento',
  },
  CREATE_PRAGMAPOWER: {
    title: 'No fue posible crear el pragmapower',
  },
};

export const ERROR_COMMENTS = {
  PUT: {
    log: '[CommentService] Error PUT comment:',
    backendTitle: 'Error al Guardar Comentario',
    backendDescription: 'No se pudo actualizar el comentario. Intente de nuevo.',
  },
};

export const ERROR_BEHAVIOR = {
  GET: {
    log: '[BehaviorService] Error GET behavior by ID:',
    backendTitle: 'Error al obtener el comportamiento',
    backendDescription: 'No se pudo obtener el comportamiento. Intente de nuevo.',
  },
};

export const ERROR_LEARNING_ACTIVITIES = {
  GET: {
    log: '[LearningActivitiesService] Error GET learning activities by technology ID & behavior ID:',
    backendTitle: 'Error al obtener las actividades de aprendizaje',
    backendDescription: 'No se pudieron obtener las actividades de aprendizaje. Intente de nuevo.',
  },
};
